import * as React from "react";
import { OpenChatConversation } from "@/types/open-chat";
import { Link } from "react-router";
import { toRelativeDate } from "@/helpers/dates";

interface Props {
  selected: boolean;
  conversation: OpenChatConversation;
}

export const SidebarHistoryRow: React.FC<Props> = ({ conversation }) => (
  <div className="mb-2 flex items-center">
    <svg viewBox="0 0 2 2" className="size-0.5 fill-current">
      <circle r={1} cx={1} cy={1} />
    </svg>
    <div className="ml-2">
      <p className="text-sm/6 font-semibold text-gray-900">
        <Link to={`/open-chat/${conversation.id}`}>{conversation.name || "Unnamed conversation"}</Link>
      </p>
      <div className="text-xs/5 text-gray-500">
        <p>
          <span className="text-xs text-gray-500">{toRelativeDate(conversation.created_at)}</span>
        </p>
      </div>
    </div>
  </div>
);
